import React from 'react';

export const CustomNoRowsOverlay = () => {
    return (
        <div style={{ textAlign: 'center', padding: '10px' }}>
            No Entity To Search
        </div>
    );
};


